import { T } from '@tribeplatform/react-components/i18n'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'
import { Text } from '@tribeplatform/react-ui-kit/Text'

export const NoBlockedMembers = () => {
  return (
    <div className="flex flex-col items-center justify-center h-full grow p-6">
      <div className="flex flex-col gap-2 items-center justify-center w-full text-center]">
        <SvgIcon name="members" size="3x" className="text-content-muted" />
        <Text className="flex text-lg font-semibold text-content-muted">
          <T
            id="Messaging.Settings.NoBlockedMembers.Title"
            defaultMessage="No blocked users"
          />
        </Text>
        <Text className="text-sm text-center text-content-muted">
          <T
            id="Messaging.Settings.NoBlockedMembers.Description"
            defaultMessage="Your block list is empty."
          />
        </Text>
      </div>
    </div>
  )
}
